import { Subject, Lesson, Absence } from 'src/store/models/timetable/index.js'
import { UserCourse } from 'src/store/models/pivot/index.js'

import { User } from 'src/store/models/index.js'
import CRUD from 'src/store/models/helper/CRUD.js'
import Users from 'src/api/users.js'

export class Course extends CRUD {
  static entity = 'courses'

  static state () {
    return {
      lesson_users: {}
    }
  }

  static fields () {
    return {
      id: this.attr(null),
      school_id: this.attr(null),
      subject_id: this.attr(null),
      season_id: this.attr(null),
      shortcut: this.attr(null),
      name: this.attr(null),
      description: this.attr(null),
      content: this.attr(null),
      is_temp: this.attr(null),
      is_custom: this.attr(null),
      is_required: this.attr(null),
      type: this.attr(null),
      intern_id: this.attr(null),
      intern_data: this.attr(null),
      init_at: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      meta: this.attr({}),
      color: this.string(''),
      user_color: this.attr(null),
      subject: this.belongsTo(Subject, 'subject_id'),
      lessons: this.hasMany(Lesson, 'course_id'),
      absences: this.morphMany(Absence, 'target_id', 'target_type'),
      users_pivot: this.hasMany(UserCourse, 'course_id'),
      users: this.belongsToMany(User, UserCourse, 'course_id', 'user_id'),
      grades_pivot: this.attr([]),
      teachers_pivot: this.attr([])
    }
  }

  static async setColor (userId, courseId, color) {
    return Users.postTtCoursesColor(userId, { course_id: courseId, color: color }, { showMessages: false })
  }

  /*
      Before creating a course, we need to modify grades_pivot and teachers_pivot
      and safe the model.id as "course_id" in the object as well.
      Since the model.id is not available (undifined) at the moment of creation (new Course(...)),
      we need this hook to add the course_id before finally creating the course.
    */
  static beforeCreate (model) {
    const { grades_pivot, teachers_pivot } = model

    model.grades_pivot = grades_pivot.map(gradePivot => ({
      grade_id: gradePivot.grade_id,
      course_id: model.id
    }))

    model.teachers_pivot = teachers_pivot.map(teacherPivot => ({
      teacher_id: teacherPivot.teacher_id,
      course_id: model.id
    }))
  }
}

export default Course
